import { ChevronDownIcon, CloseIcon } from '@calizahq/react-components-v2'
import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { getWorkspacePath } from '@sales-app/context/workspace/workspace.util'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Dropdown } from '@/components'

export const WorkspaceTabs = () => {
  const navigate = useNavigate()
  const [allTabsDropdown, setAllTabsDropdown] = useState(false)
  const [{ tabs, activeTabId, activeTabType }, workspaceDispatch] = useWorkspaceContext()

  const activeWorkspaceTab =
    activeTabId && activeTabType
      ? tabs.find((t) => t.bookablePersonId === activeTabId && t.bookablePersonType === activeTabType)
      : undefined

  const closeTab = (tab: WorkspaceTab) => {
    if (activeWorkspaceTab) {
      if (
        tab.bookablePersonId === activeWorkspaceTab.bookablePersonId &&
        tab.bookablePersonType === activeWorkspaceTab.bookablePersonType
      ) {
        if (tabs.length > 1) {
          let lastAccessedTab = tabs[0]
          tabs.forEach((t) => {
            if (t.lastAccessedTime > lastAccessedTab.lastAccessedTime) {
              lastAccessedTab = t
            }
          })

          openTab(lastAccessedTab)
        } else {
          navigate('/workspace')
        }
      }
      workspaceDispatch(WorkspaceAction.closeTab(tab))
    }
  }

  const openTab = (tab: WorkspaceTab) => {
    const { view, potentialBookingId, bookablePersonId, bookablePersonType } = tab
    const path = getWorkspacePath({
      view: view,
      type: bookablePersonType,
      id: bookablePersonId,
      potentialBookingId,
    })

    navigate(path)
  }

  const handleCloseAllTabs = () => {
    navigate('/')
    workspaceDispatch(WorkspaceAction.closeAllTabs())
  }

  return (
    <div className="flex h-12 w-full rounded-sm border border-secondary">
      <div className="flex h-full border-r bg-black px-3 text-white border-secondary">
        <Dropdown
          expanded={allTabsDropdown}
          fullScreenMobile={false}
          onHideDropdown={() => {}}
          renderToggle={() => {
            return (
              <div className="flex h-12 w-30 min-w-20 flex-nowrap items-center">
                <p className="mr-4">Open Leads</p> <ChevronDownIcon width={16} />
              </div>
            )
          }}
          setExpanded={setAllTabsDropdown}
        >
          <div className=" w-46 px-4 py-4">
            <button className="whitespace-nowrap font-medium text-action-input" onClick={handleCloseAllTabs}>
              Close all tabs
            </button>
          </div>
        </Dropdown>
      </div>
      {tabs.map((t) => {
        const isActiveTab = t.bookablePersonId === activeTabId && t.bookablePersonType === activeTabType

        const showCloseIcon = !isActiveTab || tabs.length === 1
        return (
          <button
            className={clsx(
              'flex h-full items-center justify-center border-r px-3 border-secondary',
              isActiveTab ? 'bg-white' : 'bg-action-secondary',
            )}
            key={t.bookablePersonId}
            onClick={() => openTab(t)}
          >
            <p className="mr-6">{t.label}</p>
            {showCloseIcon && (
              <CloseIcon
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  closeTab(t)
                }}
                width={16}
              />
            )}
          </button>
        )
      })}
    </div>
  )
}
